export const scrollTo = (scrollRef: string) => {
  const element = document.getElementById(scrollRef);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
};